import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { PermissionCode } from '../../user';
import { AuthUrl } from './AuthUrl';

export type PermissionQueryParams = {
  permissionCode: PermissionCode;
} & (
  | { groupId?: number }
  | { groupCode?: string }
  | { descriptionId?: number }
  | { descriptionCode?: string }
  | { versionId?: number }
);

export const getPermission = async (params: PermissionQueryParams) =>
  apiClient
    .get<boolean>(expand(AuthUrl.PERMISSION, params))
    .then((response) => response.data);

export const usePermissionQuery = createApiQueryHook(
  ['permission'],
  getPermission
);
